import { BaseViewStore, ImageCellData } from 'core/stores';
import { action, observable, makeObservable } from 'mobx';
import { tempImagePlaceholder } from 'common/constants';
import { FulfillmentOrderStore } from 'modules/order/stores';
import _ from 'lodash';

class PickingBatchListDetailViewStore extends BaseViewStore {
	@observable data = [];
	@observable change = false;
	noDataItem = true;

	constructor(rootStore, props) {
		super(rootStore);
		makeObservable(this);
		this.store = new FulfillmentOrderStore(rootStore);
		this.initialize(props);
	}

	@action.bound
	initialize = props => {
		this.tableData = {
			columns: [
				{
					key: 'image',
					title: 'PICKINGBATCHLISTVIEW.DETAIL.PRODUCTIMAGE',
					dataCell: ImageCellData,
					selected: true,
					sortable: false,
					width: 200,
					filter: null,
				},
				{
					key: 'itemSKU',
					title: 'PICKINGBATCHLISTVIEW.DETAIL.ITEMSKU',
					selected: true,
					sortable: false,
					width: 200,
					filter: null,
				},
				{
					key: 'required',
					title: 'PICKINGBATCHLISTVIEW.DETAIL.REQUIRED',
					selected: true,
					sortable: false,
					width: 200,
					filter: null,
				},
				{
					key: 'orderNumbers',
					title: 'PICKINGBATCHLISTVIEW.DETAIL.ORDERNUMBERS',
					selected: true,
					sortable: false,
					width: 200,
					filter: null,
				},
				{
					key: 'fulfillmentOrderIds',
					title: 'PICKINGBATCHLISTVIEW.DETAIL.FULFILLMENTORDERIDS',
					selected: true,
					sortable: false,
					width: 200,
					filter: null,
				},
			],
		};
		this.prepareDataItem(props.dataItem.id);
	};

	@action.bound
	setAsChanged = () => {
		this.change = !this.change;
	};

	@action.bound
	prepareDataItem = async pickingBatchId => {
		this.suspend();
		const fulfillmentOrders = (await this.store.findFulfillmentOrder({
			page: 1,
			rpp: 100,
			embed: ['order', 'fulfillmentOrderItems', 'fulfillmentOrderItems.product'],
			pickingBatchIds: [pickingBatchId],
		})).item.slice();
		let dataArray = [];
		_.each(fulfillmentOrders, fulfillmentOrder => {
			_.each(fulfillmentOrder.fulfillmentOrderItems, fulfillmentOrderItem => {
				const productData = fulfillmentOrderItem.product;
				const dataItem = {
					product: {
						image: productData.image,
						sku: fulfillmentOrderItem.sku,
						name: productData.name,
					},
					orderNumber: fulfillmentOrder.order.orderNumber,
					fulfillmentOrderId: fulfillmentOrder.fulfillmentOrderId,
					quantity: fulfillmentOrderItem.quantity,
				};
				dataArray.push(dataItem);
			});
		});
		dataArray = _.sortBy(dataArray, 'product.sku');

		const groupedData = _.groupBy(dataArray, 'product.sku');
		_.each(Object.keys(groupedData), key => {
			const ordersList = _.map(groupedData[key], item => item.orderNumber);
			const distinctFulfillmentOrderIds = [...new Set(_.map(groupedData[key], item => item.fulfillmentOrderId))];
			const quantitiesArray = _.map(groupedData[key], item => item.quantity);
			const sumOfQuantities = quantitiesArray.reduce((accumulator, value) => accumulator + value, 0);
			this.data.push({
				image: tempImagePlaceholder,
				itemSKU: key,
				required: sumOfQuantities,
				orderNumbers: _.join(_.uniq(ordersList), ' | '),
				fulfillmentOrderIds: _.join(distinctFulfillmentOrderIds, ' | '),
			});
		});
		this.resume();
	};
}

export default PickingBatchListDetailViewStore;
